<template>
  <div>
    <Top></Top>
    <div class="order-tip">
      <div class="boxWx">
        <div class="imgWx"><img src="../imgs/zhuanzhang.png"></div>
        <div>
          <p>转账支付</p>
        </div>
      </div>
    </div>
    <div class="box1">
      <p>订单号：{{ number }}</p>
      <p>应付金额：<span>￥{{ $route.query.price }}</span></p>
      <h6>请尽快进行银行转账，并在<span @click="$router.push('/userIndex')">我的订单</span>里确认已打款</h6>
      <h6>我们将在确认到账后为您开通权限，如有疑问请联系在线客服</h6>
    </div>
    <div class="box2">
      <div class="box2-top">收款账户</div>
      <div class="box2-bottom">
        <p>户名：图影数字科技（杭州）有限公司</p>
        <p>开户行：中国工商银行体东支行</p>
        <p>账号：1202007619100010410</p>
      </div>
    </div>
  </div>
</template>

<script>
import Top from "../components/top.vue";
export default {
  created() {
    this.menuNumber = this.$route.query.menuNumber
    this.getBuyInfo()
  },
  data() {
    return {
      menuNumber: '',
      number: '', //交易号（接口返回的）
    }
  },
  methods: {
    async getBuyInfo() {
      let formData = new FormData()
      formData.append('menuNumber', this.menuNumber)
      const res = await this.$axios.post('/pay/buyMemberBank', formData)
      this.number = res.data
    }
  },
  computed: {},
  watch: {},
  filters: {},
  components: { Top }
}
</script>

<style scoped lang='scss'>
.order-tip {
  display: flex;
  align-items: center;
  min-width: 1200px;
  width: 100%;
  height: 184px;
  background-color: #f9f5f2;
  padding-left: 308px;
  margin-bottom: 50px;
}

.boxWx {
  display: flex;
  align-items: center;

  .imgWx {
    margin-right: 30px;
    width: 78px;
    height: 69px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  p {
    font-family: MicrosoftYaHei;
    font-size: 36px;
    font-weight: normal;
    line-height: 50px;
    letter-spacing: 0px;
    color: #333333;
  }
}

.box1 {
  margin: 20px auto;
  width: 890px;
  height: 120px;

  // background-color: pink;
  p {
    margin-bottom: 5px;
    font-size: 16px;
    font-weight: 700;

    span {
      color: red;
    }
  }

  h6 {
    margin-bottom: 3px;
    font-size: 12px;
    color: #666;
    font-weight: normal;

    span {
      color: red;
    }
  }
}

.box2 {
  border: 1px solid #ccc;
  margin: 20px auto;
  width: 890px;
  height: 200px;

  // background-color: pink;
  .box2-top {
    padding-left: 20px;
    height: 55px;
    background-color: #ddd;
    line-height: 55px;
    font-size: 20px;
  }

  .box2-bottom {
    padding-left: 20px;
    font-size: 13px;
    font-weight: normal;
    color: #000;

    p {
      margin-top: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vip/payBank.vue